<template>
  <div v-if="src"  class="video-player">
    <video :src="src" controls></video>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    src: {
      type: String
    }
  },
  computed: {
    preview() {
      return require('@/assets/photos/view-preview.jpg')
    },
  },
}
</script>

<style lang="scss">
video {
  border: 1px solid #f2f2f2;
  border-radius: 13px;
  max-width: 500px;

  @include mobile {
    max-width: 400px;
  }
}

.video-player {
  width: 100%;
  cursor: pointer;

}
</style>
